import { CardContent } from '@mui/material';
import type { FC } from 'react';
import { Player } from '../../components/lottie/index.js';
import { CenterCard } from '../../components/page-layout/center-card.js';
import { useSetTitle } from '../../hooks/use-title.js';

export const NotFoundPage: FC = () => {
  useSetTitle('Not Found');

  return (
    <CenterCard>
      <CardContent>
        <Player
          src="https://assets7.lottiefiles.com/private_files/lf30_aiwdh2wk.json"
          sx={{ height: 350 }}
        />
      </CardContent>
    </CenterCard>
  );
};
